import { type Route } from '@/routes/route';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { LoginPath } from '@/config';

const { Page } = lazyImport(() => import('../index'), 'Page');
export const routes: Route[] = [
  {
    name: '登录',
    path: LoginPath,
    element: <Page />,
    layout: 'FullPageLayout',
    enable: true,
  },
];
